var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVLo8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Prima-Versione",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0 0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ANTICIPO-TFS---DOCUMENTI",
    transform: "translate(-750 -1891)",
    fillRule: "nonzero",
    stroke: "#FCBB00",
    strokeWidth: 4.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "v_lo_8",
    transform: "translate(753 1894)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80,40 C80,18 62,0 40,0 C18,0 0,18 0,40 C0,62 18,80 40,80 C62,80 80,62 80,40 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6065574,40 L34.9593054,51.147541 L57.704918,28.852459",
    id: "Vector"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLo8);
export default __webpack_public_path__ + "static/media/v_lo_8.538456f8fdb837479d75acf423967e43.svg";
export { ForwardRef as ReactComponent };